import script from "./DialogDam.vue?vue&type=script&setup=true&lang=ts"
export * from "./DialogDam.vue?vue&type=script&setup=true&lang=ts"

import "./DialogDam.vue?vue&type=style&index=0&id=ea035f5e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ea035f5e"]])

export default __exports__